var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.088,741.902c-82.963,19.748 -202.73,56.13 -201.391,220.596c0.716,87.989 52.319,135.824 103.986,161.505c49.889,24.797 99.626,28.277 99.626,28.277c0.443,0.032 0.887,0.048 1.331,0.048l612.167,0.218c0.665,0 1.329,-0.035 1.99,-0.105c-0,-0 230.36,-24.671 233.726,-251.946c2.82,-190.418 -155.509,-239.063 -222.889,-256.573c-7.205,-1.873 -14.582,-3.903 -18.675,-5.047c-28,-50.497 -52.757,-109.585 -111.147,-150.082c-40.937,-28.391 -98.34,-48.103 -185.272,-48.602c-121.996,-0.7 -197.016,63.26 -243.511,134.266c-43.908,67.057 -61.711,140.375 -69.941,167.445Zm4.287,372.923c-5.357,-0.476 -45.105,-4.573 -85.001,-24.403c-41.112,-20.434 -82.609,-58.215 -83.179,-128.229c-1.177,-144.667 111.216,-169.514 181.569,-185.93c3.262,-0.761 7.341,-2.485 10.961,-6.96c1.371,-1.695 3.404,-5.024 5.232,-10.228c1.968,-5.6 4.619,-15.334 8.303,-27.982c21.289,-73.071 79.743,-254.501 271.064,-253.403c76.877,0.441 127.915,16.81 164.116,41.918c55.256,38.322 76.122,95.902 102.88,143.086c1.477,2.605 4.29,6.203 9.859,8.938c4.331,2.126 14.674,4.855 29.023,8.584c58.219,15.13 197.262,55.195 194.825,219.723c-2.765,186.702 -184.902,213.295 -199.296,215.105c-0.012,0.002 -610.316,-0.216 -610.316,-0.216l-0.04,-0.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M793.242,230.479l0,-114.927",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.35,533.049l114.926,-0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.451,237.866l81.265,81.266",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.34,236.194l-81.266,81.266",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.688,676.583c24.884,-20.983 43.915,-48.048 55.241,-78.564c36.221,-97.591 -13.603,-206.23 -111.195,-242.451c-97.656,-36.246 -206.205,13.538 -242.451,111.194",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "37.5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1003);
export default __webpack_public_path__ + "static/media/1003.55ad7484ab9a2a390283bd706bd16ba9.svg";
export { ForwardRef as ReactComponent };